// extracted by mini-css-extract-plugin
export default {"hideTooltip":"X8-z","fadeIn":"Y8-z","delay":"Z8-z","recommendedSizeTooltip":"_8-z"};